module.exports = __webpack_public_path__ + "static/media/js-widget.6a0aaf20.png";